import {
  TRY_LOGIN,
  LOGIN_SUCCESS,
  SIGNUP_SUCCESS,
  LOGIN_ERROR,
  LOGIN_ALERT,
  CONFIRM_LOGIN,
  LOG_OUT,
  CLEAR_LOGIN_ERROR,
  SIGNUP_REQUEST,
  SET_MAINTENANCE_MODE,
  CLEAR_MAINTENANCE_MODE,
  SET_PASSWORD_RESET_REQUIRED,
  CLEAR_PASSWORD_RESET_REQUIRED,
} from '../constants/actionTypes';

const initState = {
  authenticating: false,
  authorized: false,
  loginErrorMessage: '',
  loginAlert: '',
  loginStatus: '',
  session: {},
  accountId: null,
  first: '',
  last: '',
  email: '',
  signup: false,
  // Maintenance mode state
  maintenance: null,
  isMaintenanceMode: false,
  // Password reset required state
  passwordResetRequired: false,
  passwordResetMessage: null,
};

const loginApp = (state = initState, action) => {
  switch (action.type) {
    case TRY_LOGIN:
      return {
        ...state,
        authenticating: true,
        signup: true,
        session: { ...state.session, email: action.email },
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        authenticating: false,
        authorized: true,
        session: { ...action.session, email: action.email },
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        signup: true,
        first: '',
        last: '',
        email: '',
      };
    case CONFIRM_LOGIN:
      return {
        ...state,
        authenticating: false,
        authorized: true,
        session: action.session,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        authenticating: false,
        authorized: false,
        loginErrorMessage: action.response.data,
        loginStatus: action.response.status,
        email: '',
        session: {},
      };
    case LOGIN_ALERT:
      return {
        ...state,
        authenticating: false,
        authorized: false,
        loginAlert: action.response.data,
        loginStatus: action.response.status,
        email: '',
        session: {},
      };
    case LOG_OUT:
      return {
        ...initState,
      };
    case CLEAR_LOGIN_ERROR:
      return {
        ...state,
        loginErrorMessage: '',
        loginAlert: '',
      };
    case SIGNUP_REQUEST:
      return {
        ...state,
        first: action.data.first,
        last: action.data.last,
        email: action.data.email,
      };
    case SET_MAINTENANCE_MODE:
      return {
        ...state,
        isMaintenanceMode: true,
        maintenance: action.payload,
      };
    case CLEAR_MAINTENANCE_MODE:
      return {
        ...state,
        isMaintenanceMode: false,
        maintenance: null,
      };
    case SET_PASSWORD_RESET_REQUIRED:
      return {
        ...state,
        passwordResetRequired: true,
        passwordResetMessage: action.payload?.message || 'Password update required',
      };
    case CLEAR_PASSWORD_RESET_REQUIRED:
      return {
        ...state,
        passwordResetRequired: false,
        passwordResetMessage: null,
      };
    default:
      return state;
  }
};

// Action creators for maintenance mode
export const setMaintenanceMode = data => ({
  type: SET_MAINTENANCE_MODE,
  payload: data,
});

export const clearMaintenanceMode = () => ({
  type: CLEAR_MAINTENANCE_MODE,
});

// Action creators for password reset required
export const setPasswordResetRequired = data => ({
  type: SET_PASSWORD_RESET_REQUIRED,
  payload: data,
});

export const clearPasswordResetRequired = () => ({
  type: CLEAR_PASSWORD_RESET_REQUIRED,
});

export default loginApp;
